import React from 'react';
import dayjs from 'dayjs';
import {DatePicker} from "antd";

import './MultiDateDisplay.scss';

interface MultiDateDisplayProps {
    dates: string[];
    dateFormat?: string;
    onClick?: () => void;
}

const MultiDateDisplay: React.FC<MultiDateDisplayProps> = ({ dates, dateFormat = 'DD/MM/YYYY', onClick }) => {
    return (
        <DatePicker
            multiple
            maxTagCount="responsive"
            minDate={dayjs()}
            format={{
                format: dateFormat,
                type: 'mask',
            }}
            placeholder="Fechas programadas"
            readOnly
            value={dates.map(date => dayjs(date))}
            allowClear={false}
            className="multi-date-display-container"
            open={false}
            onClick={onClick}
        />
    );
};

export default MultiDateDisplay;
